/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Growl } from 'primereact/growl'

import ViewCompanyComponent from '../components/ViewCompanyComponent'
import { companyActions } from '../_actions'

function ViewCompanyContainer({ selectedCompany, getCompanyById }) {
  const growl = useRef()
  return (
    <div className="p-grid pageWrapper">
      <Growl ref={growl} />
      <ViewCompanyComponent
        selectedCompany={selectedCompany}
        getCompanyById={getCompanyById} />
    </div>
  )
}

ViewCompanyContainer.propTypes = {
  selectedCompany: PropTypes.object,
  getCompanyById: PropTypes.func
}
const mapStateToProps = state => {
  return {
    selectedCompany: state.company.singleEntry
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCompanyById: (id) => dispatch(companyActions.getCompanyById(id))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewCompanyContainer)
